import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { cloneDeep } from 'lodash';

import { GridTableColumnModel } from './grid-table-column.model';


@Component({
  selector: 'rnpl-grid-table',
  templateUrl: './grid-table.component.html',
  styleUrls: ['./grid-table.component.scss'],
})
export class GridTableComponent implements OnChanges {

  public columnsGrid: string;
  public _columns: GridTableColumnModel[] = [];

  @Input() set columns(columns: GridTableColumnModel[]) {
    this._columns = cloneDeep(columns);
  }
  @Input() rows: any = []; // todo: add model
  @Input() title: string;
  @Input() clickableRows = false;

  @Output() rowClickedEmit: EventEmitter<any> = new EventEmitter<any>();

  // public pagination: PaginationModel = { ...DEFAULT_PAGINATION, per_page: 1000 };
  // public sort: FilterModelNew = { sortBy: 'createdAt', direction: DEFAULT_SORT_DIRECTION };

  // readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.hasOwnProperty('columns')) {
      this.getColumnsGrid();
    }
  }

  private getColumnsGrid(): void {
    this.columnsGrid = this._columns.reduce((acc, c) => acc + ' ' + c.width, '');
  }

  public rowClick(row): void {
    this.rowClickedEmit.emit(row);
  }

  public sort(col: GridTableColumnModel): void {
    const forwardSortDirection: 'ASC'|'DESC' = !col.sortDirection
      ? 'ASC'
      : col.sortDirection === 'ASC'
        ? 'DESC'
        : 'ASC';

    this._columns
      .filter(c => c.prop !== col.prop)
      .forEach(c => c['sortDirection'] = null);

    const direction = forwardSortDirection === 'ASC'
      ? 1
      : -1;

    try {
      if (col.sortFn) {
        this.rows.sort((a, b) => direction * col.sortFn(a, b));
      } else {
        this.rows.sort((a, b) => direction * (a[col.prop] || '').localeCompare((b[col.prop] || '')));
      }
    } catch (e) {}

    col.sortDirection = forwardSortDirection;
  }

  // ngOnDestroy() {
  //   this.destroy$.next(true);
  //   this.destroy$.complete();
  // }

}
